export enum PenaltyTypeEnum {
    BALL_ABUSE = 'BALL_ABUSE',
    COACHING = 'COACHING',
    DRESS_CODE_VIOLATION = 'DRESS_CODE_VIOLATION',
    EQUIPMENT_VIOLATION = 'EQUPIMENT_VIOLATION',
    FAILURE_TO_SIGN_IN = 'FAILURE_TO_SIGN_IN',
    FAILURE_TO_COMPLETE = 'FAILURE_TO_COMPLETE',
    INELIGIBILITY = 'INELIGIBILITY',
    LEAVING_THE_COURT = 'LEAVING_THE_COURT',
    NO_SHOW = 'NO_SHOW',
    PHYSICAL_ABUSE = 'PHYSICAL_ABUSE',
    PROHIBITED_SUBSTANCE = 'PROHIBITED_SUBSTANCE',
    PUNCTUALITY = 'PUNCTUALITY',
    RACQUET_ABUSE = 'RACQUET_ABUSE',
    REFUSAL_TO_PLAY = 'REFUSAL_TO_PLAY',
    UNSPORTSMANLIKE_CONDUCT = 'UNSPORTSMANLIKE_CONDUCT',
    VERBAL_ABUSE = 'VERBAL_ABUSE',
    OTHER = 'OTHER',

    UNREASONABLE_DELAYS = 'UNREASONABLE_DELAYS',
    AUDIBLE_OBSCENITY = 'AUDIBLE_OBSCENITY',
    VISIBLE_OBSCENITY = 'VISIBLE_OBSCENITY',


}
